import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { addSchemaToHead, removeExistingSchema } from '@/utils/seoUtils';

interface BreadcrumbItem {
  name: string;
  url: string;
}

interface BreadcrumbSchemaProps {
  customBreadcrumbs?: BreadcrumbItem[];
}

const BreadcrumbSchema: React.FC<BreadcrumbSchemaProps> = ({ customBreadcrumbs }) => {
  const location = useLocation();

  useEffect(() => {
    const generateBreadcrumbs = (): BreadcrumbItem[] => {
      if (customBreadcrumbs) {
        return customBreadcrumbs;
      }

      const pathSegments = location.pathname.split('/').filter(Boolean);
      const baseUrl = 'https://www.carolinatrophyroofs.com';
      
      const breadcrumbs: BreadcrumbItem[] = [
        { name: 'Home', url: baseUrl }
      ];

      let currentPath = '';
      pathSegments.forEach((segment, index) => {
        currentPath += `/${segment}`;
        
        // Create readable names for path segments
        let name = segment
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');

        // Special cases for common routes
        if (segment === 'frequently-asked-questions') {
          name = 'FAQ';
        } else if (segment === 'book-inspection') {
          name = 'Book Inspection';
        } else if (segment === 'service-areas') {
          name = 'Service Areas';
        } else if (segment === 'locations') {
          name = 'Locations';
        } else if (segment === 'resources') {
          name = 'Resources';
        } else if (segment === 'services') {
          name = 'Services';
        } else if (segment === 'contact') {
          name = 'Contact';
        }

        breadcrumbs.push({
          name,
          url: `${baseUrl}${currentPath}`
        });
      });

      return breadcrumbs;
    };

    const breadcrumbs = generateBreadcrumbs();
    
    // Only add breadcrumbs for pages with more than just home
    if (breadcrumbs.length > 1) {
      const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": breadcrumbs.map((item, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "name": item.name,
          "item": item.url
        }))
      };

      addSchemaToHead(breadcrumbSchema);
    }
  }, [location, customBreadcrumbs]);

  return null;
};

export default BreadcrumbSchema;